/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import RatesTab from './RatesTab';
import ContactDetailTab from './ContactDetailTab';
import HearingsTab from './HearingsTab';
import HistoricalRateTab from './HistoricalRateTab';
import FeedbackPanel from '../_components/feedbackPanel';
import { fetchTaxingUnitPollQuestions } from '../../api/questions';

const RATES_TAB = 'Rates';
const HEARINGS_TAB = 'Hearings';
const CONTACT_TAB = 'Contact Details';
const HISTORICAL_TAB = 'Historical Tax Rates';
const FEEDBACK_TAB = 'Feedback';
const tabs = [
  RATES_TAB,
  HEARINGS_TAB,
  CONTACT_TAB,
  HISTORICAL_TAB,
  FEEDBACK_TAB,
];

const UnitWrapper = ({
  unit,
  buildLineChartConfig,
  isUseTaxElectionRate,
  isWaterRate,
  openWorksheetPDF,
  parseFloatKeep,
  showLastYearTaxes,
  showNotPublishedForZeroTaxRate,
  taxingUnitChartType,
  openHearingWindow,
  fetchTaxingUnit,
  showBudgetInformation,
  showHistoricalTaxRates,
  buildLineHChartConfig,
  params,
  fetchHistoricalRates,
  taxpayerFeedbackEnabled,
  captchaKey,
  apiBaseUrl,
  token,
  submitFeedack,
  pushToast,
  showSB2Disclaimer,
  ownerId,
}) => {
  const [ currentTab, setCurrentTab ] = useState(0);
  const getFilteredTabs = () => {
    if (showHistoricalTaxRates) {
      return tabs;
    }
    return tabs.filter(t => t !== HISTORICAL_TAB);
  };

  const showDisclaimer = Boolean(showSB2Disclaimer && unit && unit.taxingUnitType === 'School');
  return (
    <div className='custom-container'>
      <div className='title'>
        <span>
          {unit.taxingUnitName}
        </span>
        <span className='taxing-code'>Taxing Unit Code: {unit.taxingUnitCode}</span>
      </div>
      <div className='tax-wrapper'>
        <div className='tab-wrapper'>
          <Tab currentTab={currentTab} setCurrentTab={(tab) => setCurrentTab(tab)} tabs={getFilteredTabs()} />
        </div>
        {
          (!currentTab || currentTab === RATES_TAB) &&
          <RatesTab
            buildLineChartConfig={buildLineChartConfig}
            isUseTaxElectionRate={isUseTaxElectionRate}
            isWaterRate={isWaterRate}
            openWorksheetPDF={openWorksheetPDF}
            parseFloatKeep={parseFloatKeep}
            showLastYearTaxes={showLastYearTaxes}
            showNotPublishedForZeroTaxRate={showNotPublishedForZeroTaxRate}
            taxingUnitChartType={taxingUnitChartType}
            unit={unit}
          />
        }
        {
          currentTab === HEARINGS_TAB &&
          <HearingsTab
            openHearingWindow={openHearingWindow}
            unit={unit}

          />
        }
        {
          currentTab === CONTACT_TAB &&
          <ContactDetailTab
            fetchTaxingUnit={fetchTaxingUnit}
            openWorksheetPDF={openWorksheetPDF}
            showBudgetInformation={showBudgetInformation}
            unit={unit}
          />
        }
        {
          currentTab === HISTORICAL_TAB &&
          <HistoricalRateTab
            buildLineChartConfig={buildLineChartConfig}
            buildLineHChartConfig={buildLineHChartConfig}
            fetchHistoricalRates={fetchHistoricalRates}
            isUseTaxElectionRate={isUseTaxElectionRate}
            isWaterRate={isWaterRate}
            ownerId={ownerId}
            parseFloatKeep={parseFloatKeep}
            propertyID={params.propertyId}
            taxingUnitChartType={taxingUnitChartType}
            unit={unit}
          />
        }
        {
          currentTab === FEEDBACK_TAB &&
          <>
            {
              taxpayerFeedbackEnabled &&
            <FeedbackPanel
              captchaKey={captchaKey}
              fetchTaxingUnitPollQuestions={fetchTaxingUnitPollQuestions.bind(
                null,
                apiBaseUrl,
                token
              )}
              handleSubmit={(data) => submitFeedack({ ...data, selectedUnitId: unit.taxingUnitID, selectedUnitYear: unit.taxingUnitYr, selectedProperty: unit.propID })}
              pushToast={pushToast}
              unitId={unit.taxingUnitID}
              year={unit.taxingUnitYr}
            />
            }
          </>
        }
      </div>
      {
        showDisclaimer ? (
          <div style={{ padding: '15px 40px 15px 40px', backgroundColor: '#fdcd3c' }}>
            <div>The school district taxable value displayed above reflects the provisional requirements of SB2, The Property Tax Relief Act, to increase the residence homestead exemption to $100,000. This increase is contingent on voter approval at an election to be held in November 2023. If that change is not approved by the voters, the exemption amount will revert to $40,000 and a supplemental bill may be mailed to you.</div>
          </div>
        ) : null
      }
    </div>
  );
};

UnitWrapper.propTypes = {
  apiBaseUrl: PropTypes.any,
  buildLineChartConfig: PropTypes.func.isRequired,
  buildLineHChartConfig: PropTypes.func.isRequired,
  captchaKey: PropTypes.any,
  fetchHistoricalRates: PropTypes.func.isRequired,
  fetchTaxingUnit: PropTypes.func.isRequired,
  isUseTaxElectionRate: PropTypes.func.isRequired,
  isWaterRate: PropTypes.func.isRequired,
  openHearingWindow: PropTypes.func.isRequired,
  openWorksheetPDF: PropTypes.func.isRequired,
  ownerId: PropTypes.any,
  params: PropTypes.any,
  parseFloatKeep: PropTypes.func.isRequired,
  pushToast: PropTypes.func.isRequired,
  showBudgetInformation: PropTypes.any,
  showHistoricalTaxRates: PropTypes.any,
  showLastYearTaxes: PropTypes.any,
  showNotPublishedForZeroTaxRate: PropTypes.any,
  showSB2Disclaimer: PropTypes.any,
  submitFeedack: PropTypes.func.isRequired,
  taxingUnitChartType: PropTypes.any,
  taxpayerFeedbackEnabled: PropTypes.any,
  token: PropTypes.any,
  unit: PropTypes.any,
};

export default UnitWrapper;
